export const CDN_BASE_URL =
  "https://static.share.market/images/blog";

export const IMG_VARIANTS = {
  FEATURED: "_featured",
  ALL_ARTICLES: "_all_articles",
  MOST_POPULAR: "_most_popular",
  WEB_BANNER: "_web_banner",
  MOBILE_BANNER: "_mobile_banner",
};

export const getFeaturedImgUrl = slug =>
  `${CDN_BASE_URL}/564/206/${slug}${IMG_VARIANTS.FEATURED}.png`;

export const getAllArticlesImgUrl = slug =>
  `${CDN_BASE_URL}/514/290/${slug}${IMG_VARIANTS.ALL_ARTICLES}.png`;

export const getMostPopularImgUrl = slug =>
  `${CDN_BASE_URL}/248/176/${slug}${IMG_VARIANTS.MOST_POPULAR}.png`;

export const getWebBannerImgUrl = slug =>
  `${CDN_BASE_URL}/1280/336/${slug}${IMG_VARIANTS.WEB_BANNER}.png`;

export const getMobileBannerImgUrl = slug =>
  `${CDN_BASE_URL}/360/185/${slug}${IMG_VARIANTS.MOBILE_BANNER}.png`;

export const getImgUrl = (slug, imgVariant) => {
  switch (imgVariant) {
    case IMG_VARIANTS.FEATURED:
      return getFeaturedImgUrl(slug);
    case IMG_VARIANTS.ALL_ARTICLES:
      return getAllArticlesImgUrl(slug);
    case IMG_VARIANTS.MOST_POPULAR:
      return getMostPopularImgUrl(slug);
    case IMG_VARIANTS.WEB_BANNER:
      return getWebBannerImgUrl(slug);
    case IMG_VARIANTS.MOBILE_BANNER:
      return getMobileBannerImgUrl(slug);
    default:
      return "";
  }
};
